<template>
  <div class="form-group">
    <div class="d-flex justify-content-between">
      <label v-if="label" class="form-label text-muted">
        {{ label }} <i v-if="required" class="text-danger">*</i>
      </label>
      <slot name="labelContentEnd"></slot>
    </div>
    <input
      v-if="readOnly"
      class="form-control form-disabled"
      :value="value"
      disabled
      :style="inputStyle"
    />
    <input
      v-else-if="model"
      class="form-control"
      v-maska
      :data-maska="mask"
      :lang="'pt-BR'"
      v-model.trim="model.$model"
      :class="{ 'is-invalid': model.$error }"
      :type="type"
      :placeholder="placeholder"
      :style="inputStyle"
      :maxlength="maxLength ?? undefined"
      :min="minDate ?? undefined"
    />
    <div class="invalid-feedback">
      <small>{{ errorMessage }}</small>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { vMaska } from "maska";

export interface IModal {
  $errors?: Array<{ $message: string }>;
  $error: any;
  $model: string;
}

const props = withDefaults(
  defineProps<{
    model?: IModal | null;
    type?: string;
    label?: string;
    placeholder?: string;
    errorMsg?: string;
    value?: string;
    readOnly?: boolean;
    maxLength?: number | null;
    minDate?: string | null;
    inputStyle?: string | null;
    required?: boolean;
    mask?: string;
  }>(),
  {
    model: null,
    type: "text",
    label: "",
    placeholder: "",
    errorMsg: "Por favor, preencha este campo corretamente",
    value: "",
    readOnly: false,
    maxLength: null,
    minDate: null,
    inputStyle: null,
    required: false,
    mask: "",
  },
);

const errorMessage = computed(() =>
  props.model && props.model.$errors
    ? props.model.$errors.find((e) => e)?.$message || props.errorMsg
    : props.errorMsg,
);
</script>
